<template>
  <div class="tabson1" >
<!--    <label >{{queryData.taxReportTime}} </label>
    <label >{{queryData.taxCompanyName}} </label>
    税金申报情况：<label style="color: #5daf34">{{ queryData.taxReportStatus | bspTableFilter({'1':'dict','2':dicts}) }}</label>
    <label style="color: #409EFF">&ensp;{{ queryData.taxPayStatus | bspTableFilter({'1':'dict','2':dicts}) }}</label>-->
<!--    <el-button type="primary" size="small" @click="backToCodeSet()" style="float: right">返回</el-button>-->

    <bsp-table
      :data.sync="list"
      ref="accountTable"
			id="accountTable"
      show-footer
      :footer-method="footerMethod"
      :custom-config="{storage: true}"
      :ciic-data-filter.sync="listQuery"
      @ciic-data-refresh="_getTaxQuitWagesList"
      :showPagination="listQuery.page"
      style="width: 100%"
    >
      <bsp-table-column
        field="A0010001"
        title="工号"

        width="10%">
        <template slot-scope="scope">{{ scope.row.A0010001 }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="empName"
        title="姓名"

        width="10%">
        <template slot-scope="scope">{{ scope.row.empName }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="idCardType"

        title="证照类型"
        width="10%">
        <template slot-scope="scope">{{ scope.row.idCardType  | bspTableFilter({'1':'dict','2':dicts}) }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="idCard"
        label="证照号码"
        width="10%">
        <template slot-scope="scope">{{ scope.row.idCard }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="payAmount"
        title="一次性补偿收入"

        width="10%">
        <template slot-scope="scope">{{ scope.row.payAmount }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="thisActTax"
        title="个税"

        width="10%">
        <template slot-scope="scope">{{ scope.row.thisActTax }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="otherFree"
        title="免税收入"

        width="10%">
        <template slot-scope="scope">{{ scope.row.otherFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="otherFee"
        title="其他"

        width="10%">
        <template slot-scope="scope">{{ scope.row.otherFee }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="donationFree"

        title="准予扣除的捐赠额"
        width="10%">
        <template slot-scope="scope">{{ scope.row.donationFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="preTaxFree"

        title="减免税额"
        width="10%">
        <template slot-scope="scope">{{ scope.row.preTaxFree }}</template>
      </bsp-table-column>
      <bsp-table-column
        field="remarks"

        title="备注"
        width="10%">
        <template slot-scope="scope">{{ scope.row.remarks }}</template>
      </bsp-table-column>
    </bsp-table>


  </div>
</template>
<script>
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import {getTaxList,getTaxBatchById,updateTaxBatch,getBatchEmpByIdList,getEmpDetailByIdList,getEmpWagesDetailList,getTaxQuitWagesList} from "@/api/tax/tax";
  import {mapGetters} from 'vuex';
  export default {
    name: "tabson1",
    components: { bspTableColumn, bspTable},
    props:{
      currentTab:{
        type:String,
        default:''
      }
    },
    watch: {

    },
    created(){
      this.queryData=this.$route.query
      // console.log(this.batchId)
      this._getTaxQuitWagesList()

    },
    mounted(){

    },
    computed: {
      ...mapGetters([
        'dicts',
        'pms'
      ]),
    },
    data() {
      return {
        sumListCode:[
          'payAmount',
          'thisActTax',
          'otherFree',
          'donationFree',
          'preTaxFree'
        ],//需要合计的列信息
        queryData:null,
        list:[],
        listQuery:{
          limit: 20,
          page: 1,
          total: 0,
          batchId:this.$route.query.batchId,
          taxType:this.$route.query.taxType

        }
      }
    },
    methods:{
      footerMethod ({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {

            /*if(data&&data.length>0){
              let columFiled = column.property;
              let result = XEUtils.every(data,(data)=>{
                return data[columFiled] ===0 || data[columFiled]===null
              })
              if(result){
                this.hiddenColumns.push(columFiled)
              }
            }*/

            if (columnIndex === 3) {
              return '合计'
            }
            if (this.sumListCode.includes(column.property)) {
              return XEUtils.sum(data, column.property)
            }
            return null
          })
        ]
      },
      _getTaxQuitWagesList(){
        getTaxQuitWagesList(this.listQuery).then(res => {
          console.log(res);
          this.listQuery.total = res.data.total
          this.list = res.data.records
        } ).catch((error) => {
          console.log("错误信息"+error)
        })
      },
      backToCodeSet(){
        this.$router.go(-1)
      },
    }

  }
</script>
<style scoped="scoped">
	 #accountTable >>> .vxe-table .vxe-table--header-wrapper{
		 width: 100%;
	 }
</style>

